/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'portfolio-outline': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M8.29 2.512a.833.833 0 01.877.832l-.001 7.49h7.49c.445 0 .806.348.832.782v.094a8.75 8.75 0 11-9.197-9.198zM7.168 4.607l-.162.031C3.76 5.294 2 7.838 2 11.255 2 15.167 4.95 18 8.861 18c3.417 0 5.916-1.729 6.572-4.973l.03-.163H8a.833.833 0 01-.828-.736l-.005-.097V4.607zM11.833.001c4.613-.079 8.326 3.666 8.158 8.1l.003.222a.833.833 0 01-.833.845h-7.328A.833.833 0 0111 8.335v-7.5c0-.46.373-.826.833-.834zM13 2.08v5.121h4.942l-.026-.187a6.062 6.062 0 00-4.722-4.907L13 2.08z" _fill="currentColor"/>'
  }
})
